import * as stylex from '@stylexjs/stylex';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { useRouter, type ErrorComponentProps } from '@tanstack/react-router';

import { HttpException } from '@/libs/openapi';
import { Button, Heading } from '@/libs/serenity-ui';

export function ErrorState({ error, reset }: ErrorComponentProps) {
  const router = useRouter();

  const { reset: queryErrorReset } = useQueryErrorResetBoundary();

  if (error instanceof HttpException) {
    return (
      <div {...stylex.props(styles.container)}>
        <div {...stylex.props(styles.contentContainer)}>
          <Heading color="placeholder" level={1} size={52} style={styles.heading}>Couldn’t load the data</Heading>
          <Button
            isRounded
            size={40}
            onPress={() => {
              queryErrorReset();
              reset();
              router.invalidate();
            }}>
            Try again
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.contentContainer)}>
        <Heading color="placeholder" level={1} size={52} style={styles.heading}>Something went wrong</Heading>
        <Button isRounded size={40} onPress={reset}>Reload</Button>
      </div>
    </div>
  );
}

const styles = stylex.create({
  container: {
    height: '100%',
    width: '100%',
  },
  contentContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    justifyContent: 'center',
    paddingTop: 160,
    width: '100%',
  },
  heading: {
    textAlign: 'center',
  },
});
